// extracted by mini-css-extract-plugin
export var actions = "_2t-0";
export var actionsContainer = "_2t-7";
export var border = "_2t-1";
export var childFullHeight = "_2t-f";
export var collapse = "_2t-2";
export var content = "_2t-a";
export var contentChild = "_2t-e";
export var fullscreen = "_2t-c";
export var hasLeftRadius = "_2t-k";
export var headerContainer = "_2t-3";
export var headerRow = "_2t-5";
export var hidePadding = "_2t-b";
export var navCollapsedGap = "_2t-l";
export var noScrollX = "_2t-m";
export var noScrollY = "_2t-n";
export var noTopPadding = "_2t-i";
export var optOutTopPadding = "_2t-d";
export var pageMain = "_2t-j";
export var pageOuter = "_2t-g";
export var pagePadding = "_2t-8";
export var pageScroll = "_2t-9";
export var profile = "_2t-o";
export var profileContainer = "_2t-p";
export var profileImage = "_2t-q";
export var profileMain = "_2t-r";
export var profileSubtitle = "_2t-t";
export var profileTitle = "_2t-s";
export var showLeftPadding = "_2t-h";
export var tabsPortalSlot = "_2t-6";
export var tabsWrapper = "_2t-4";
export var title = "_2t-u";